import React from "react"

import { Home, XCircle } from "lucide-react"
import { Link } from "react-router-dom"

import AppLayout from "@/components/layout/AppLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { SUPPORT_EMAIL } from "@/constants/contact"

const AssessmentFailedPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto max-w-lg px-4 py-6">
        <Card>
          <CardHeader className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="rounded-full bg-red-100 p-3">
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
            </div>
            <CardTitle className="text-xl font-bold text-jungle">Assessment Not Passed</CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="rounded-lg border border-red-200 bg-red-50 p-4">
              <p className="mb-2 font-medium text-red-800">
                You did not meet the required score for this assessment
              </p>
              <p className="text-sm text-red-700">
                Unfortunately, you did not achieve the minimum score required to proceed to the next
                stage of the application process at this time.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium text-gray-900">What happens next?</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  You can reapply and retake the assessment in 30 days
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  Review our driver requirements before reapplying
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  Consider the scenarios presented in the assessment and how you might approach them
                  differently
                </li>
              </ul>
            </div>

            <div className="rounded-lg bg-gray-50 p-4">
              <p className="text-sm text-gray-600">
                If you have questions about your assessment or application, please contact us at{" "}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-honeycomb hover:underline">
                  {SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </CardContent>

          <div className="space-y-3 p-6 pt-0">
            <Link to="/application-status" className="block w-full">
              <Button variant="outline" className="w-full">
                Check Application Status
              </Button>
            </Link>
            <Link to="/" className="block w-full">
              <Button className="w-full bg-honeycomb hover:bg-amber-500">
                <Home className="mr-2 h-4 w-4" /> Return to Home
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </AppLayout>
  )
}

export default AssessmentFailedPage
